import React from "react";
import { Box, Grid, Typography, Divider } from "@mui/material";

type BookRowProps = {
  title: string;
  data: Array<{ [key: string]: string }>;
};

const BookRow = ({ title, data }: BookRowProps) => {
  return (
    <Grid item xs={6}>
      <Typography pb={2} variant="h5" component="h3">
        {title}
      </Typography>
      <Divider />
      <Box className="account-data">
        {data.map((d) => (
          <Box className="data-row">
            <Typography variant="subtitle1" component="h6">
              {d.title}
            </Typography>
            <Typography variant="body2" component="h6">
              {d.value}
            </Typography>
          </Box>
        ))}
      </Box>
    </Grid>
  );
};
export default BookRow;
